exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-scroll {\r\n\tposition:relative;\r\n\tmax-width:100%;\r\n\tmargin:auto;\r\n\toverflow:hidden;\r\n}\r\n.table-wrap {\r\n\twidth:100%;\r\n\toverflow:auto;\r\n}\r\n.table-scroll table {\r\n\twidth:100%;\r\n\tmargin:auto;\r\n\tborder-collapse:separate;\r\n\tborder-spacing:0;\r\n}\r\n.table-scroll th, .table-scroll td {\r\n\tpadding:5px 10px;\r\n\tbackground:#fff;\r\n\twhite-space:nowrap;\r\n\tvertical-align:top;\r\n}\r\n.table-scroll thead, .table-scroll tfoot {\r\n\tbackground:#f9f9f9;\r\n}\r\n.clone {\r\n\tposition:absolute;\r\n\ttop:0;\r\n\tleft:0;\r\n\tpointer-events:none;\r\n}\r\n.clone th, .clone td {\r\n\tvisibility:hidden\r\n}\r\n.clone td, .clone th {\r\n\tborder-color:transparent\r\n}\r\n.clone tbody th {\r\n\tvisibility:visible;\r\n\tcolor:red;\r\n}\r\n.clone .fixed-side {\r\n\tbackground:#eee;\r\n\tvisibility:visible;\r\n}\r\n.clone thead, .clone tfoot{background:transparent;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/assets/css/table-scroll.css
// module id = ../../../../../src/assets/css/table-scroll.css
// module chunks = main